module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"section":{"prefix":"その他の","title":"{prefix}説明会"}}}')
  delete Component.options._Ctor
}
